import React from 'react';

export const PilotAssignmentStoreContext = React.createContext(null);
